import React from "react";

const LOGO_URL = "/brand/logo.png";

export default function Logo({ size = "default", showWordmark = false }) {
  const dimension = size === "lg" ? 140 : size === "sm" ? 60 : 96;

  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="7 Spices Indian Cuisine"
        width={dimension}
        height={dimension}
        style={{ width: dimension, height: dimension, objectFit: "contain" }}
        className="drop-shadow-sm select-none"
        draggable={false}
      />
      {showWordmark && (
        <span className="font-serif text-2xl leading-none tracking-tight">
          7 Spices
        </span>
      )}
    </div>
  );
}
